module.exports = __webpack_public_path__ + "static/testimonial-f6d8a864069b17b7a244aab8122eadb9.png";